export enum StorefrontWidgetCartCardIcon {
  Gift = "gift",
  Shield = "shield",
  Lock = "lock",
}
